import { useTranslation } from 'react-i18next'

import { ActionModal, Modal, Typography } from '@percent/lemonade'

export type SetDefaultTemplateModalProps = {
  open: boolean
  handleClose: VoidFunction
  handleSetDefault: VoidFunction
  isLoading: boolean
}

export function SetDefaultTemplateModal({
  open,
  handleClose,
  handleSetDefault,
  isLoading
}: Readonly<SetDefaultTemplateModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose} data-testid="set-default-template-modal">
      <ActionModal
        title={t('dialog.templates.setDefault.title')}
        primaryButtonText={t('button.setDefaultTemplate')}
        secondaryButtonText={t('button.cancel')}
        handleClose={handleClose}
        handleSubmit={handleSetDefault}
        loading={isLoading}
      >
        <Typography>{t('dialog.templates.setDefault.description')}</Typography>
        <Typography>{t('dialog.templates.setDefault.confirmation')}</Typography>
      </ActionModal>
    </Modal>
  )
}
